import type { APIResponse } from "../types/common";

import { processError } from "../utils";

export async function oauthAuthorize(
  bearerToken: string,
  {
    clientId,
    redirectUri,
    responseType = "code",
    scope = "identify",
  }: {
    clientId: string;
    redirectUri: string;
    responseType?: string;
    scope?: string;
  }
): Promise<APIResponse<{ code: string }>> {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE}/api/oauth2/authorize`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${bearerToken}`,
        },
        method: "PUT",
        body: JSON.stringify({
          clientId,
          redirectUri,
          responseType: responseType === "" ? "code" : responseType,
          scope:
            scope === ""
              ? ["identify"]
              : scope.trim().toLowerCase().split(/ +/),
        }),
      }
    );

    if (response.status !== 200)
      return {
        success: false,
        error: response.status.toString().startsWith("5")
          ? "Invalid request: " + response.status
          : processError(await response.json()),
      };

    const body = await response.json();
    return {
      success: true,
      data: body,
    };
  } catch (e) {
    return {
      success: false,
      error: processError(e),
    };
  }
}
